import React from "react";

// Premium shimmer skeletons used across pages while data loads. Replaces
// flat animate-pulse blocks with a directional shimmer sweep.
export const SkeletonBlock = ({ className = "" }) => (
  <div className={`lv-skeleton rounded-lg border border-white/[0.05] ${className}`} />
);

export const SkeletonGrid = ({
  count = 8,
  blockClassName = "h-52",
  cols = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  className = "",
}) => (
  <div data-testid="skeleton-grid" className={`grid gap-4 ${cols} ${className}`}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonBlock key={i} className={blockClassName} />
    ))}
  </div>
);
